var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"24px"}},[_c('a-spin',{attrs:{"spinning":_vm.detailSpinning}},[_c('practice-detail-form',{attrs:{"article":_vm.article,"reviewInfo":_vm.reviewInfo},on:{"submitSuccess":_vm.getPracticeInfo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04364729","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PracticeDetail/PracticeDetailOutIndex.vue
// module id = null
// module chunks = 